var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.cities,"item-text":"name","loading":_vm.loading,"value":_vm.city,"disabled":!_vm.country_area,"hint":!_vm.country_area
      ? _vm.capitalize(_vm.$tc('model.address_message_first_pick_a_country_area'))
      : '',"persistent-hint":"","return-object":""},on:{"change":_vm.handleSelect}},'v-autocomplete',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }